// Shared team data — used by About (compact tiles) and Team (full profiles).
export const OPERATORS = [
    {
        slug: "andrew",
        name: "Andrew",
        role: "Chief Executive Officer",
        photo: "https://customer-assets.emergentagent.com/job_bd-on-demand/artifacts/2dmids4w_Andrew.ce7ebb070368d105dfee.png",
        bio: "Serial entrepreneur with a proven track record of scaling category-defining companies across ad-tech, e-commerce, and digital media — having built and exited businesses representing over $2B in aggregate enterprise value and creating 2,200+ jobs. Today he's focused on what he sees as the next great shift in digital commerce: live social selling — a $175B U.S. market projected to reach $800B by 2030.",
        quote: "We're not just building an ad platform — we're building the infrastructure for the $800B live social commerce economy of tomorrow.",
    },
    {
        slug: "paul",
        name: "Paul",
        role: "Chief Operating Officer",
        photo: "https://customer-assets.emergentagent.com/job_bd-on-demand/artifacts/rhabkns4_Paul.4ce04805742844249550.png",
        bio: "Seasoned entrepreneur with a track record of building companies in emerging markets and technology. After years of helping live social sellers grow their streams, he identified their biggest challenge: audience growth and sales.",
        quote: "If your audience doesn't know you're live, you're not selling — you're streaming into silence. Advertising is the mic check before the spotlight hits.",
    },
    {
        slug: "punhon",
        name: "Punhon",
        role: "Chief Technology Officer",
        photo: "https://customer-assets.emergentagent.com/job_bd-on-demand/artifacts/jaynsafh_PunhanDesktop.15da14a806c7558fc277.png",
        bio: "Veteran engineering leader with more than two decades driving innovation in ad-tech and digital media. He has built and scaled platforms that power billions of impressions, combining deep technical expertise with a sharp eye for monetization strategy. Specializes in harnessing AI and automation to replace manual processes, ensure compliance, and unlock new growth opportunities for digital commerce.",
        quote: null,
    },
    {
        slug: "frank",
        name: "Frank",
        role: "Chief Media Officer",
        photo: "https://customer-assets.emergentagent.com/job_bd-on-demand/artifacts/rh9xm74m_FrankDesktop.242835376c88ca78f597.png",
        bio: "Strategic, results-driven digital advertising leader with 12+ years across technical integrations, operational excellence, go-to-market and business development. Proven success navigating complex programmatic ecosystems, optimizing ad operations, and cultivating high-impact partnerships that drive revenue. Leverages data analytics to streamline operations, ensure compliance with GDPR, COPPA and CCPA, and deliver measurable outcomes for leading global brands.",
        quote: null,
    },
];
